<app-base-modal
  [title]="titleModal()"
>
  @if (isLoading) {
    <app-loader/>
  }
  <app-custom-mat-select
    [label]="'Артикул'"
    [options]="articleSelectData()"
    [needEmptyValue]="false"
    [fullWidth]="true"
    (selectedChange)="handleSelectChange($event)"
  />
  <div class="buttons-container">
    <button
      mat-button
      class="save-button"
      [disabled]="!selectedArticleId()"
      (click)="confirmCopy()"
    >
      Создать
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Отмена
    </button>
  </div>
</app-base-modal>
